import { User } from '@/shared/models/user';

const userMockData: User = {
  id: '69c9033c-9ee9-4cd8-9331-6ef8e50081ea',
  firstName: 'John',
  lastName: 'Smith',
  email: 'johnsmith@example.com',
  isInternalUser: false,
};

export default userMockData;
